import {
  base_colorAction,
  base_colorAlert,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_regular, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

// The name without edit permission. Inherits the meta row's own type and colour
// rather than restating them, so the read-only name is typographically identical
// to the trigger it replaces — the only difference a permitted user sees is the
// pencil.
export const readOnlyName = css`
  font: inherit;
  color: inherit;
`

export const editForm = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacing(1)};
`

// Visually hidden, still in the a11y tree — the input's label must exist for
// assistive tech without adding a second visible label to a one-line meta row.
export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`

export const input = css`
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextPrimary};
  padding: ${spacing(0.5)} ${spacing(1)};
  border: 1px solid ${base_colorAction};
  border-radius: 4px;
  min-width: 0;
  width: 18ch;

  &:focus-visible {
    outline: 2px solid ${base_colorAction};
    outline-offset: 1px;
  }

  &:disabled {
    cursor: progress;
  }
`

export const action = css`
  ${font_md};
  font-family: ${font_family_weight_regular};
  border: none;
  background: none;
  padding: 0;
  color: ${base_colorAction};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${base_colorAction};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: progress;
    opacity: 0.6;
  }
`

export const error = css`
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${base_colorAlert};
  display: block;
  margin-top: ${spacing(1)};
`
